import SwaggerKafkaUtils from './Kafka/KafkaUtils'
import SwaggerMicroservices from './Microservices/MicroservicesParser'
import SwaggerPaths from './Paths/PathsParser'
import SwaggerMicroservicesUtils from './Microservices/MicroservicesUtils'
import SwaggerDefinitions from './Definitions/DefinitionsParser'
import { TParsedConstellationSwaggerAPI, TSwaggerfiles } from './types'

export default ({
  baseURL: unvalidatedBaseURL = '',
  swaggerfiles,
}: {
  baseURL?: string
  swaggerfiles: TSwaggerfiles
}): TParsedConstellationSwaggerAPI => {
  const validatedBaseUrl = unvalidatedBaseURL.replace(/\/$/, '')

  const paths = SwaggerPaths(swaggerfiles, validatedBaseUrl)
  const microservices = SwaggerMicroservices(swaggerfiles)
  const microservicesUtils = SwaggerMicroservicesUtils(swaggerfiles)
  const definitions = SwaggerDefinitions(swaggerfiles)
  const kafkaUtils = SwaggerKafkaUtils(swaggerfiles)

  return {
    microservices,
    paths,
    definitions,
    microservicesUtils,
    kafkaUtils,
  }
}
